var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Editor } from "../../screens/back-admin/ContentEditor";
var EditPresentation = /** @class */ (function (_super) {
    __extends(EditPresentation, _super);
    function EditPresentation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditPresentation.prototype.render = function () {
        return (React.createElement("section", null,
            React.createElement("div", { className: "row text-center" },
                React.createElement("h2", { className: "col-12" }, "Modification du contenu de l'onglet \"Pr\u00E9sentation\"")),
            React.createElement(Editor, { type: "presentation" })));
    };
    return EditPresentation;
}(React.Component));
export { EditPresentation };
